<template>
  <div class="inline-block">
    <div :class="[`${typeClasses.badge} p-px flex items-center rounded`]">
      <icon
        v-if="icon"
        :icon="icon"
        :class="[`block w-5 h-5 ${typeClasses.icon}`]"
      />
      <span
        :class="['text-2xs leading-none tracking-wide font-bold uppercase mx-4', slotClasses]"
      >
        <slot />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppBadge",
  props: {
    icon: {
      type: String,
      required: false,
      default: ""
    },
    slotClasses: {
      type: String,
      required: false,
      default: ""
    },
    type: {
      type: String,
      default: "primary",
      validator(value) {
        return (
          [
            "primary",
            "secondary",
            "grey",
            "positive",
            "negative",
            "neutral"
          ].indexOf(value) !== -1
        );
      }
    }
  },
  computed: {
    typeClasses() {
      let badge = "";
      let icon = "";
      switch (this.type) {
        case "primary":
          badge = "bg-primary-100 text-primary-900";
          icon = "icons-primary";
          break;
        case "secondary":
          badge = "bg-secondary-300 text-secondary-900";
          icon = "icons-secondary";
          break;
        case "grey":
          badge = "bg-grey-200 text-grey-900";
          icon = "icons-grey";
          break;
        case "positive":
          badge = "bg-positive-100 text-positive-900";
          icon = "icons-positive";
          break;
        case "negative":
          badge = "bg-negative-100 text-negative-900";
          icon = "icons-negative";
          break;
        case "neutral":
          badge = "bg-neutral-100 text-neutral-900";
          icon = "icons-neutral";
          break;
      }
      return {
        badge,
        icon
      };
    }
  }
};
</script>
